import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import tw, { styled } from "twin.macro"

import List from "../content/list"
import JobAd from "../article/jobad"

const JobadderListing = ({ ...props }) => {
  const {
    jobs: { nodes: jobs },
  } = useStaticQuery(query__jobs)

  return (
    <Style className="promotion promotion--jobadder-listing" {...props}>
      {jobs.length > 0 ? (
        <React.Fragment>
          <h2>Current vacancies</h2>
          <List
            items={jobs.map((item) => {
              return {
                title: item.title,
                body: item.summary,
                reference: item.reference,
                link: item.path.alias,
                terms: item.terms,
                //bulletPoints: item.bulletPoints
              }
            })}
            Element={JobAd}
          />
        </React.Fragment>
      ) : (
        <p>
          Sorry, we don't have any open positions at the moment. Please check
          back later.
        </p>
      )}
    </Style>
  )
}
export default JobadderListing

const query__jobs = graphql`
  query {
    jobs: allJobAdderJob(
      sort: { postAt: DESC }
      filter: { title: { ne: "" } }
    ) {
      nodes {
        adId
        title
        summary
        reference
        expireAt
        terms {
          fieldName
          value
        }
        postAt(formatString: "YYYY")
        path {
          alias
        }
      }
    }
  }
`

const Style = styled.section`
  ${tw` px-4 mx-auto [maxWidth:100ch]`}

  * + & {
    ${tw`mt-5`}
  }

  > h2 {
    ${tw`text-xl lg:text-3xl mg:text-4xl font-semibold mb-6 lg:mb-12 text-center`}
    ${tw`grid font-semibold text-center text-3xl md:text-4xl mb-4`}
  }
`
